import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';

class SpecTestsRightingReactionsStrategy extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_RightingReactionsStrategy' name='Righting Reactions Strategy' visible={false} flagged={this.props.flagged}>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} header='Righting Reactions Strategy' />);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRRSANKLE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRRSUE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRRSKNEE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRRSUNABLE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSRRSHIP) {
        flagged = true;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'RightingReactionsStrategy'),
        flagged: flagged
    };
}

const connectedSpecTestsRightingReactionsStrategy = connect(mapStateToProps)(SpecTestsRightingReactionsStrategy);
export { connectedSpecTestsRightingReactionsStrategy as SpecTestsRightingReactionsStrategy };



